import React from 'react';
import { Grid, GridItem, Title, Subtitle } from '@landing/ui';
import { Container } from 'components/UI';
import * as styles from './AboutTheCourse.module.scss';

export default function AboutTheCourse({
  title,
  subtitle,
  items = [],
  gutterX = '30px',
  gutterY = '30px',
  colsXsm = 2,
  colsSm = 2,
  colsMd = 5,
  colsLg = 5,
}) {
  return (
    <Container id="about">
      <div className={styles.layout}>
        <Title tag="h2">{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <div className={styles.cards}>
          <Grid
            xsm={{ cols: colsXsm }}
            sm={{ cols: colsSm }}
            md={{ cols: colsMd }}
            lg={{ cols: colsLg }}
            xl={{ cols: colsLg }}
            gutterY={gutterY}
            gutterX={gutterX}
          >
            {items.map(({ name, value }) => (
              <GridItem key={name}>
                <div>
                  <div className={styles.name}>{name}</div>
                  <div className={styles.value}>{value}</div>
                </div>
              </GridItem>
            ))}
          </Grid>
        </div>
      </div>
    </Container>
  );
}
